// @flow
import styled from "styled-components";
import { below } from "../../assets/css/media";

export const DraftTitleContainer = styled.div`
	padding-top: 30px;

	${below.desktop`
		padding: 30px 15px 0;
	`};
`;

export default DraftTitleContainer;


// WEBPACK FOOTER //
// ./src/components/Draft/DraftTitleContainer.js